export const CategoryOptions = [
  { label: "Film & Animation", value: "Film & Animation" },
  { label: "Music", value: "Music" },
  { label: "Pets & Animals", value: "Pets & Animals" },
  { label: "Sports", value: "Sports" },
  { label: "Short Movies", value: "Short Movies" },
  { label: "Travel & Events", value: "Travel & Events" },
  { label: "Autos & Vehicles", value: "Autos & Vehicles" },
  { label: "Gaming", value: "Gaming" },
  { label: "Videoblogging", value: "Videoblogging" },
  { label: "People & Blogs", value: "People & Blogs" },
  { label: "Comedy", value: "Comedy" },
  { label: "Entertainment", value: "Entertainment" },
  { label: "News & Politics", value: "News & Politics" },
  { label: "Howto & Style", value: "Howto & Style" },
  { label: "Education", value: "Education" },
  {
    label: "Science & Technology",
    value: "Science & Technology",
  },
  { label: "Movies", value: "Movies" },
  { label: "Anime/Animation", value: "Anime/Animation" },
  { label: "Action/Adventure", value: "Action/Adventure" },
  { label: "Classics", value: "Classics" },
  { label: "Comedy", value: "Comedy" },
  { label: "Documentary", value: "Documentary" },
  { label: "Drama", value: "Drama" },
  { label: "Family", value: "Family" },
  { label: "Foreign", value: "Foreign" },
  { label: "Horror", value: "Horror" },
  { label: "Sci-Fi/Fantasy", value: "Sci-Fi/Fantasy" },
  { label: "Thriller", value: "Thriller" },
  { label: "Shorts", value: "Shorts" },
  { label: "Shows", value: "Shows" },
  { label: "Trailers", value: "Trailers" },
];

export const VisibilityOptions = [
  { label: "Public", value: "public" },
  { label: "Private", value: "private" },
  { label: "Unlisted", value: "unlisted" },
];

export interface YoutubePublishInterface {
  id: string;
  platform: string;
  channel_name: string;
  playlist: string;
  is_created_for_kids: string;
  category: string;

  monetize_policy_id: string;
  title: string;
  desc: string;
  tags: string[];
  thumb: string | undefined;
  thumbId: string | undefined;
  status: number;
  msg: string;
  privacy: string;
  job_type: string;
  upload_type: string;
  media_id: string;
  ct: number;
  mt: number;
  schedule?: number;
  title_ai_type?: string;
  title_ai_value?: string;
  desc_ai_type?: string;
  desc_ai_value?: string;
  title_ai_checked?: boolean;
  desc_ai_checked?: boolean;
  isNew?: number;
  is_rights_managements_allowed: string;
  schedule_after?: number;
}

export interface FacebookPublishInterface {
  id: string;
  pageName: string;
  platform: string;
  title: string;
  desc: string;
  tags: string[];
  thumb: string;
  thumbId: string;
  privacy: string;
  status: number;
  job_type: string;
  upload_type: string;
  media_id: string;
  msg: string;
  channel_name: string;
  ct: number;
  mt: number;
  image: string;
  schedule?: number;
  title_ai_type?: string;
  title_ai_value?: string;
  desc_ai_type?: string;
  desc_ai_value?: string;
  isChecked?: boolean;
  isNew?: number;
  title_ai_checked?: boolean;
  desc_ai_checked?: boolean;
  schedule_after?: number;
}

export interface DenmarkPublishInterface {
  host?: number;
  section: number;
  channel_name?: string;
  title?: string;
  privacy?: string;
  desc?: string;
  tags: string[];
  thumb?: string;
  thumbId?: string;
  platform: string;
  title_for_url?: string;
  job_type: string;
  upload_type: string;
  media_id: string;
  id: string;
  ct: number;
  mt: number;
  status: number;
  msg?: string;
  isNew?: number;
}

export const agencyCategoryOptions = [
  { label: "INHOUSE", value: 1, badge: "primary", css: "bg-primary" },
  { label: "WIRED", value: 2, badge: "dark", css: "bg-warning text-dark" },
  { label: "STRINGERS", value: 3, badge: "success", css: "bg-secondary" },
  { label: "GROUP", value: 4, badge: "secondary", css: "bg-light text-dark" },
];

export const discoverVisibilityOptions = [
  { label: "All Uploads", value: 1 },
  { label: "All Streamable Content", value: 2 },
  { label: "All Published Content", value: 3 },
];
